import { Hero } from "../sections/Hero";
import { TrustMarquee } from "../sections/TrustMarquee";
import { WarumWir } from "../sections/WarumWir";
import { SoFunktioniert } from "../sections/SoFunktioniert";
import { Zielgruppen } from "../sections/Zielgruppen";
import { EnergyCoach } from "../sections/EnergyCoach";
import { MeetBeraterin } from "../sections/MeetBeraterin";
import { Testimonials } from "../sections/Testimonials";
import { FaqSection } from "../sections/FaqSection";
import { Seo } from "../components/Seo";
import { CONTACT } from "../data/content";

const schema = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  name: "Energie-Tarifberater",
  description: "Unabhängige Energieberatung für Strom & Gas in Deutschland.",
  telephone: CONTACT.phone,
  email: CONTACT.email,
  address: {
    "@type": "PostalAddress",
    streetAddress: CONTACT.street,
    addressLocality: "Hamburg",
    postalCode: "22769",
    addressCountry: "DE",
  },
  areaServed: "DE",
  priceRange: "Kostenlos",
};

export default function Home() {
  return (
    <>
      <Seo
        title="Unabhängige Strom- & Gasberatung"
        description="Kostenlose Analyse Ihrer Strom- oder Gasrechnung. Unabhängig, persönlich und deutschlandweit. Angebot in 24 Stunden – 9 von 10 Kunden sparen."
        path="/"
        schema={schema}
      />
      <Hero />
      <TrustMarquee />
      <WarumWir />
      <SoFunktioniert />
      <Zielgruppen />
      <EnergyCoach />
      <MeetBeraterin />
      <Testimonials />
      <FaqSection />
    </>
  );
}
